import React, { useEffect, useState } from "react";
import { MaitreOeuvre, Org, User } from "../types/basicTypes";
import { useAuth } from "../auth/FirebaseAuth";
import { useAppContext } from "../config/AppContext";
import {
  getDocDataById,
  getFlutterTime,
  queryCollection,
} from "../models/DataFunctions";
import { updateCreateApi } from "../api/database/updateCreateApi";
import SexySpin from "../assets/SexySpinner";
import ModalRight from "../modals/ModalRight";
import DropDownGPT03 from "../dropdown/DropDownGTP03";
import PrimaryButton from "../buttons/PrimaryButton";
import BasicSearchBar from "../textfields/BasicSearchBar";
import Icon1 from "../assets/icons/Icon";
import TabGPT from "../tabs/TabGPT";
import DataGridGPT2 from "../tables/DataGridGPT2";
import Space from "../layout/Space";
import { transformPartnersToTable } from "../models/OrgFunctions";
import updateDocApi from "../api/database/updateDocApi";
import SecondaryButton from "../buttons/SecondaryButton";
import deleteDocApi from "../api/database/deleteDocApi";
import createDocApi from "../api/database/createDocApi";
import {
  generateID,
  InfosBlockModify,
} from "./attestations/helpers/generalHelpers";
import PrimaryButtonWhite from "../buttons/PrimaryButtonWhite";
import PartnerImportComponent from "../modals/PartnerImportComponent";

interface PartnersProps {
  userData: User;
  orgData: Org;
  overrideId?: any;
  navigateWorkspace: (path: string) => void;
  setCanFetchFolders?: (canFetch: boolean) => void;
  handleClickVariant: (
    message: string,
    variant: "default" | "error" | "success" | "warning" | "info" | undefined
  ) => void;
}

function Partners({
  userData,
  orgData,
  overrideId,
  navigateWorkspace,
  setCanFetchFolders,
  handleClickVariant,
}: PartnersProps) {
  const { currentUser, loading } = useAuth();
  const [tag_open, setTagOpen] = useState(false);
  const { appState, setAppState, filter } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const folders_config = appState.folders_config;
  const saved_data = appState.saved_data;
  const [importOpen, setImportOpen] = useState(false);

  const [searchValue, setSearchValue] = useState(
    folders_config?.search_value || ""
  );
  const [rows, setRows] = useState<any>([]);
  const [columns, setColumns] = useState<any>([]);
  const [options, setOptions] = useState<
    {
      value: string;
      label: string;
    }[]
  >([]);
  const [year, setYear] = useState(null);
  const [loadingRows, setLoadingRows] = useState(true);

  const years = [
    { value: 2024, label: "2024" },
    { value: 2025, label: "2025" },
  ];

  const [tag_folder_id, setTagFolderId] = useState(null);
  const [tag_index, setTagIndex] = useState(1);
  // Function to navigate to a client by ID
  const gotoFolder = (object: any) => {
    setModifyClient(true);
    setUpdatedPartner(partners.find((partner) => partner.id === object.id));
  };

  const gotoNewFolder = () => {
    navigateWorkspace(`/newpartner`);
  };

  // Function to navigate to a client by name
  const gotoFolderName = (option: any) => {
    handleSearchChange(option.label);
    // Find the client with the matching name
  };

  const [update_search, setUpdateSearch] = useState(false);
  const handleSearchChange = async (name: any) => {
    handleSetSeachValue(name);
    setUpdateSearch(true);
  };

  const [tabs = [], setTabs] = useState<{ label: string; id: string }[]>([
    { label: "Tous", id: "all" },

    { label: "Architectes", id: "architect" },
    { label: "Constructeurs", id: "constructor" },
    { label: "Promoteurs", id: "promotor" },
    { label: "Maîtres d'oeuvre", id: "mdo" },

    { label: "Autres", id: "other" },
  ]);

  const [allfolders, setAllFolders] = useState([]);
  const tabContent = [<span></span>, <span></span>, <span></span>];
  const [particulier_folders, setParticulierFolders] = useState([]);

  const [masters, setMasters] = useState([]);
  const [only_folder_filter, setOnlyFolderFilter] = useState(
    folders_config?.only_folder_filter || null
  );
  const [selected_ids, setSelectedIds] = useState<string[]>([]);
  const [loadingDelete, setLoadingDelete] = useState(false);
  const [activetab, setActiveTab] = useState("all");
  const [clients, setClients] = useState([]);
  const [partners, setPartners] = useState<MaitreOeuvre[]>([]);

  const [searchFolders, setSearchFolders] = useState(
    folders_config?.search_folders || "folders"
  );
  const [tagFilterOpen, setTagFilterOpen] = useState(false);
  const [tag_filters, setTagFilters] = useState([]);

  const [users, setUsers] = useState([]);
  const [modifyClient, setModifyClient] = useState(false);
  const [updatedPartner, setUpdatedPartner] = useState<
    MaitreOeuvre | undefined
  >(undefined);
  const handleTabChange = (newTab: any) => {
    setActiveTab(newTab);
  };

  const handleSetSeachValue = async (value: any) => {
    setSearchValue(value);
  };
  let newsearchFolders = folders_config?.search_folders || "folders";
  const handleFetchData = async () => {
    if (userData) {
      try {
        // Fetch user data by currentUser's ID

        // Parallel fetching of organization and clients

        let tab = "architect";
        // if no clients in constructor and one in architect, set active tab to architect
        let filters = [
          {
            field: "org_id",
            operator: "==",
            value: orgData.id,
          },
        ];
        let partners = (await queryCollection(
          "partner",
          filters
        )) as MaitreOeuvre[];
        // if no clients in constructor and one in architect, set active tab to architect

        // Transform clients into table format (rows and columns)

        // Update state if the user data is new or changed
        // Batch state updates to minimize re-renders
        setPartners(partners);

        // Set search bar options in a single call, filtering only clients with a name
        setOptions(
          partners
            .filter((partner) => partner.name)
            .map((partner) => ({ value: partner.id, label: partner.name }))
        );
        setLoadingRows(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const handleCreateNewPartner = async () => {
    const newPartner: MaitreOeuvre = {
      id: generateID("partner"),
      name: "Nouveau partenaire",
      partner_type: "other",
      address: "",
      postal: "",
      city: "",
      email: "",
      phone: "",
      country: "France",
      siret: "",
      org_id: orgData.id,
      creation_date: getFlutterTime(),
    };
    await createDocApi("partner", newPartner, prefix);
    let new_created = await getDocDataById("partner", newPartner.id);
    setPartners([...partners, new_created]);
    setUpdatedPartner(new_created);
    setModifyClient(true);
    handleClickVariant("Le partenaire a été créé avec succès.", "success");
  };

  const handleSaveClientAsPartner = async () => {
    // check if client with folderData.infos.maitre_oeuvre_infos?.id exists in appState.partners and if not, add it to the state
    if (!updatedPartner) {
      handleClickVariant("Aucun partenaire à modifier.", "error");
      return;
    }

    await updateDocApi("partner", updatedPartner.id, updatedPartner, prefix);

    handleClickVariant(
      "Le partenaire a été mis à jour avec succès.",
      "success"
    );

    setModifyClient(false);
    setUpdatedPartner(undefined);
    handleFetchData();
  };

  const handleDeleteSelectedParnters = async () => {
    if (selected_ids.length === 0) {
      handleClickVariant("Aucun partenaire sélectionné.", "error");
      return;
    }
    setLoadingDelete(true);
    try {
      await Promise.all(
        selected_ids.map(async (id) => {
          const partner = partners.find((p) => p.id === id);
          if (partner && partner.ref) {
            await deleteDocApi(partner.ref, prefix);
            setPartners((prev) => prev.filter((p) => p.id !== id));
          }
        })
      );
      handleClickVariant(
        "Les partenaires sélectionnés ont été supprimés avec succès.",
        "success"
      );
      setSelectedIds([]);
    } catch (error) {
      console.error("Error deleting partners:", error);
      handleClickVariant(
        "Erreur lors de la suppression des partenaires.",
        "error"
      );
    } finally {
      setLoadingDelete(false);
    }
  };

  const handleDeletePartner = async (partner: MaitreOeuvre) => {
    if (!partner.ref) {
      handleClickVariant("Aucun partenaire à supprimer.", "error");
      return;
    }
    try {
      await deleteDocApi(partner.ref!, prefix);
      setPartners(partners.filter((p) => p.id !== partner.id));
      handleClickVariant(
        "Le partenaire a été supprimé avec succès.",
        "success"
      );
      setModifyClient(false);
      setUpdatedPartner(undefined);
    } catch (error) {
      console.error("Error deleting partner:", error);
      handleClickVariant(
        "Erreur lors de la suppression du partenaire.",
        "error"
      );
    }
  };

  const [loadingSelection, setLoadingSelection] = useState("");

  useEffect(() => {
    if (userData) {
      handleFetchData();
    }
  }, [userData]);

  useEffect(() => {
    const { rows, columns } = transformPartnersToTable(
      partners,
      activetab,
      searchValue
    );

    setRows(rows);
    setColumns(columns);
  }, [partners, activetab, searchValue]);

  if (loading || !currentUser || !userData || loadingRows) {
    return (
      <div className="h-full w-full pl-4 flex flex-col items-center justify-center gap-2">
        <SexySpin></SexySpin>
      </div>
    );
  }

  if (importOpen) {
    return (
      <PartnerImportComponent
        onClose={() => {
          setImportOpen(false);
          handleFetchData();
        }}
        orgData={orgData}
        prefix={prefix}
      ></PartnerImportComponent>
    );
  }

  // Render the client data
  return (
    <div className="flex flex-col h-full  pl-4 pr-4 overflow-auto">
      <div className="flex flex-col h-fit w-full">
        {modifyClient && updatedPartner && (
          <ModalRight
            isOpen={modifyClient}
            onClose={() => {
              handleFetchData();
              setModifyClient(false);
            }}
          >
            <div
              className="flex flex-col gap-4 p-4 w-c500
      
          "
            >
              <div className="text-h2 text-black">Modifier un partenaire</div>
              <div className="flex flex-col gap-2">
                <InfosBlockModify
                  label="ID"
                  value={updatedPartner?.id || ""}
                  onChange={(value: string) => {}}
                  disabled={true}
                ></InfosBlockModify>
                <InfosBlockModify
                  label="Nom"
                  value={updatedPartner?.name || ""}
                  onChange={(value: string) => {
                    setUpdatedPartner({
                      ...updatedPartner,
                      name: value,
                    });
                  }}
                ></InfosBlockModify>
                <DropDownGPT03
                  label="Type de partenaire"
                  items={[
                    {
                      value: "architect",
                      label: "Architecte",
                    },
                    {
                      value: "constructor",
                      label: "Constructeur",
                    },
                    {
                      value: "promotor",
                      label: "Promoteur",
                    },
                    {
                      value: "mdo",
                      label: "Maître d'oeuvre",
                    },
                    {
                      value: "other",
                      label: "Autre",
                    },
                  ]}
                  value={updatedPartner?.partner_type || ""}
                  onChange={(value: any) => {
                    setUpdatedPartner({
                      ...updatedPartner,
                      partner_type: value,
                    });
                  }}
                ></DropDownGPT03>
                <InfosBlockModify
                  label="Adresse"
                  value={updatedPartner.address || ""}
                  onChange={(value: string) => {
                    setUpdatedPartner({
                      ...updatedPartner,
                      address: value,
                    });
                  }}
                ></InfosBlockModify>
                <InfosBlockModify
                  label="Code postal"
                  value={updatedPartner.postal || ""}
                  onChange={(value: string) => {
                    setUpdatedPartner({
                      ...updatedPartner,
                      postal: value,
                    });
                  }}
                ></InfosBlockModify>
                <InfosBlockModify
                  label="Ville"
                  value={updatedPartner.city || ""}
                  onChange={(value: string) => {
                    setUpdatedPartner({
                      ...updatedPartner,
                      city: value,
                    });
                  }}
                ></InfosBlockModify>
                <InfosBlockModify
                  label="Email"
                  value={updatedPartner.email || ""}
                  onChange={(value: string) => {
                    setUpdatedPartner({
                      ...updatedPartner,
                      email: value,
                    });
                  }}
                ></InfosBlockModify>{" "}
                <InfosBlockModify
                  label="Téléphone"
                  value={updatedPartner.phone || ""}
                  onChange={(value: string) => {
                    setUpdatedPartner({
                      ...updatedPartner,
                      phone: value,
                    });
                  }}
                ></InfosBlockModify>
              </div>
              <div className="flex flex-row gap-2 ">
                <PrimaryButton
                  onClick={() => {
                    handleSaveClientAsPartner();
                  }}
                >
                  Enregistrer
                </PrimaryButton>
                <SecondaryButton
                  onClick={() => {
                    handleDeletePartner(updatedPartner);
                  }}
                >
                  Supprimer le partenaire
                </SecondaryButton>
              </div>
            </div>
          </ModalRight>
        )}
        <div className="flex flex-row w-full h-full  pr-6">
          <div className="flex flex-col gap-4 h-full w-full max-h-full overflow-auto ">
            <div className="flex flex-row gap-1 ">
              <div className="text-hx font-medium">Partenaires</div>{" "}
            </div>
            <div className="flex  gap-2 flex-row max-w-c1p2k 2xl:justify-between h-fit">
              <div className="flex flex-row justify-between w-full gap-2 items-center">
                {/* Search Bar */}
                <BasicSearchBar
                  orgData={orgData}
                  options={options}
                  setValue={handleSetSeachValue}
                  value={searchValue}
                  onAction={() => {}}
                  placeholder="Rechercher un partenaire..."
                />
                <div className="flex flex-row gap-2">
                  <PrimaryButtonWhite onClick={() => setImportOpen(true)}>
                    Importer
                  </PrimaryButtonWhite>
                  <PrimaryButton onClick={handleCreateNewPartner}>
                    Nouveau partenaire
                  </PrimaryButton>
                </div>
              </div>
            </div>
            {selected_ids.length === 0 && searchValue === "" && (
              <div className="flex flex-row gap-2">
                <div className="ml-0 pl-0 left-0 relative">
                  <TabGPT
                    tabs={tabs}
                    activeTab={activetab}
                    setActiveTab={handleTabChange}
                  />
                </div>{" "}
              </div>
            )}
            {selected_ids.length > 0 && (
              <PrimaryButton onClick={handleDeleteSelectedParnters}>
                Supprimer les partenaires sélectionnés
                {loadingDelete && <SexySpin />}
              </PrimaryButton>
            )}
            {/* DataGrid displaying the clients */}
          </div>
        </div>
      </div>{" "}
      <div className="w-full h-full max-h-[60%]  max-w-full mt-2">
        <DataGridGPT2
          selectable={true}
          rows={rows}
          columns={columns}
          searchValue={searchValue || ""}
          onClick={gotoFolder}
          initial_asc={"asc"}
          initialPage={0}
          initialPageSize={100}
          orgData={orgData}
          selected_ids={selected_ids}
          setSelectedIds={setSelectedIds}
        ></DataGridGPT2>
      </div>
    </div>
  );
}

export default Partners;

export const getTypeString = (type: string | undefined): string => {
  switch (type) {
    case "architect":
      return "Architecte";
    case "constructor":
      return "Constructeur";
    case "promotor":
      return "Promoteur";
    case "mdo":
      return "Maître d'oeuvre";
    case "other":
      return "Autre";
    default:
      return "";
  }
};
// This function converts a partner type string to a human-readable format.
